/**
 * The Hospital Equipment Company — buyer-experience fixes (Oct 10, 2026).
 * (Theme hooks: 'variant:changed', 'product:added', 'cart:refresh' — see Warehouse docs.)
 * Request a Quote lives in assets/quote-request.js.
 *
 * 1. Selection guard: Add to Quote / Add to Cart / full quote form always use the
 *    options currently selected, even if the theme hasn't finished updating the variant.
 * 2. Full quote form link carries configuration, extra fields and quantity.
 * 3. Shipping estimator limited to the United States, "State" label.
 * 4. Mobile collection pages: long intro collapsed behind "Read more"; sticky
 *    filter bar sits below the real header height.
 */
(function () {
  'use strict';

  /* ---------------- helpers ---------------- */

  function parseJSON(s) { try { return JSON.parse(s); } catch (e) { return null; } }

  function productDataFor(form) {
    var btn = form && form.querySelector('[data-quote-product]');
    return btn ? parseJSON(btn.getAttribute('data-quote-product')) : null;
  }

  // Values of option1..optionN exactly as the shopper has them selected right now.
  // Option inputs carry value IDs, so read the visible text (option text or swatch label title).
  function optionControls(form, name) {
    var els = Array.prototype.slice.call(form.querySelectorAll('[name="' + name + '"]'));
    if (!els.length && form.id) els = Array.prototype.slice.call(document.querySelectorAll('[name="' + name + '"][form="' + form.id + '"]'));
    return els;
  }

  function selectedOptionValues(form) {
    var values = [];
    for (var i = 1; i <= 3; i++) {
      var els = optionControls(form, 'option' + i);
      if (!els.length) break;
      var val = '';
      var sel = els.filter(function (e) { return e.tagName === 'SELECT'; })[0];
      if (sel) {
        var opt = sel.options[sel.selectedIndex];
        val = opt ? opt.textContent.trim() : '';
      } else {
        var radio = els.filter(function (e) { return e.type === 'radio' && e.checked; })[0];
        if (radio) {
          var label = radio.id ? document.querySelector('label[for="' + radio.id + '"]') : null;
          val = label ? (label.getAttribute('title') || label.textContent.trim()) : '';
        } else {
          var hidden = els.filter(function (e) { return e.type === 'hidden'; })[0];
          if (!hidden) val = '';
          else return [];
        }
      }
      values.push(val);
    }
    return values;
  }

  // Variant matching the current selections (variant titles are "A / B / C").
  function currentVariant(form) {
    var product = productDataFor(form);
    if (!product || !product.variants) return null;
    var values = selectedOptionValues(form);
    if (!values.length || values.indexOf('') > -1) return null;
    var title = values.join(' / ');
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].title === title) return product.variants[i];
    }
    return null;
  }

  function syncIdField(form) {
    var v = currentVariant(form);
    if (!v) return null;
    var idField = form.querySelector('[name="id"]');
    if (idField && String(idField.value) !== String(v.id)) idField.value = v.id;
    return v;
  }

  function mainProductForm() {
    var forms = document.querySelectorAll('form.product-form');
    for (var i = 0; i < forms.length; i++) {
      if (!forms[i].closest('.modal') && !forms[i].closest('template')) return forms[i];
    }
    return null;
  }

  /* ------------- 1. selection guard (capture phase, runs before theme + quote scripts) ------------- */

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var btn = t.closest('[data-quote-add], .product-form__add-button, .shopify-payment-button__button');
    if (!btn) return;
    var form = btn.closest('form.product-form');
    if (!form) return;
    var v = syncIdField(form);
    // A $0 (quote-only) configuration must never go to the cart, even mid-update.
    if (v && Number(v.price) === 0 && !btn.hasAttribute('data-quote-add')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var q = form.querySelector('[data-quote-add]');
      if (q) q.click();
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form.product-form')) return;
    var v = syncIdField(form);
    if (v && Number(v.price) === 0) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  /* ------------- 2. full quote form link carries the whole configuration ------------- */

  function collectProps(form) {
    var scope = form || document;
    var fields = scope.querySelectorAll('[data-quote-prop]');
    var map = {}, order = [];
    Array.prototype.forEach.call(fields, function (el) {
      var name = el.getAttribute('data-quote-prop');
      var val = '';
      if (el.type === 'checkbox' || el.type === 'radio') {
        if (!el.checked) return;
        val = el.value;
      } else {
        val = (el.value || '').trim();
      }
      if (!name || !val) return;
      if (!map.hasOwnProperty(name)) { map[name] = []; order.push(name); }
      map[name].push(val);
    });
    return order.map(function (n) { return n + ': ' + map[n].join('; '); });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('a.facility-buy__link[href*="/pages/request-a-quote?product="]');
    if (!link) return;
    var form = link.closest('form.product-form') || mainProductForm();
    if (!form) return;
    var product = productDataFor(form);
    var v = currentVariant(form);
    if (!v) {
      var idField = form.querySelector('[name="id"]');
      if (product && idField) {
        for (var i = 0; i < product.variants.length; i++) {
          if (String(product.variants[i].id) === String(idField.value)) { v = product.variants[i]; break; }
        }
      }
    }
    var qtyField = form.querySelector('input[name="quantity"]');
    var params = new URLSearchParams();
    params.set('product', product ? product.title : document.title);
    if (v) {
      if (v.sku) params.set('sku', v.sku);
      params.set('option', v.title);
      params.set('url', (product ? product.url : window.location.pathname) + '?variant=' + v.id);
    }
    params.set('qty', String(Math.max(1, parseInt(qtyField && qtyField.value, 10) || 1)));
    var details = collectProps(form);
    if (details.length) params.set('details', details.join('\n'));
    link.href = '/pages/request-a-quote?' + params.toString();
  }, true);

  /* ------------- 3. shipping estimator: US only, "State" ------------- */

  function fixEstimator() {
    document.querySelectorAll('select[name="country"]').forEach(function (sel) {
      if (sel.__thecUS) return;
      var us = null;
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (o.value === 'United States') us = o;
      });
      if (!us) return;
      sel.__thecUS = true;
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        if (o !== us) o.remove();
      });
      sel.value = 'United States';
      sel.setAttribute('data-default', 'United States');
      sel.dispatchEvent(new Event('change', { bubbles: true }));
    });
    document.querySelectorAll('label[for$="province"], label[for*="province"]').forEach(function (label) {
      if (/province/i.test(label.textContent)) label.textContent = label.textContent.replace(/province/i, 'State');
    });
  }

  /* ------------- 4a. mobile collection intro: "Read more" ------------- */

  function collapseCollectionIntro() {
    var box = document.querySelector('.collection__description');
    if (!box || box.__thecCollapsed || !box.classList.contains('expandable-content')) return;
    if (!window.matchMedia('(max-width: 699px)').matches) return;
    if (box.scrollHeight < 220) return;
    box.__thecCollapsed = true;
    box.classList.add('thec-clamp');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'thec-readmore link link--accented';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = 'Read more';
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('thec-clamp--open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Show less' : 'Read more';
    });
    box.parentNode.insertBefore(btn, box.nextSibling);
  }

  /* ------------- 4b. sticky offset = real header height ------------- */

  function stickyHeaderBottom() {
    var header = document.querySelector('.header');
    var el = header;
    while (el && el !== document.body) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') return el.getBoundingClientRect().height;
      el = el.parentElement;
    }
    return 0;
  }

  function fixStickyOffset() {
    var h = stickyHeaderBottom();
    if (h > 0) document.documentElement.style.setProperty('--thec-sticky-top', Math.round(h) + 'px');
  }

  function init() {
    fixEstimator();
    collapseCollectionIntro();
    fixStickyOffset();
    if (window.MutationObserver) {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        setTimeout(function () { pending = false; fixEstimator(); }, 60);
      }).observe(document.body, { childList: true, subtree: true });
    }
    window.addEventListener('resize', function () { setTimeout(fixStickyOffset, 50); });
    setTimeout(fixStickyOffset, 600);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
